export default __webpack_public_path__ + "static/flex-casestudy-cover-8af1fce62b3eb268471e4d322f9d4a61.svg";